import cn from 'classnames'

export const MuteButton = ({
  muted,
  onToggle,
  className,
}: {
  muted: boolean
  onToggle: () => void
  className?: string
}) => (
  <button
    onClick={(e) => {
      e.stopPropagation()
      onToggle()
    }}
    className={cn(
      'flex items-center gap-2 rounded-full bg-moss-grey-500/30 px-3 py-1.5 text-12 text-moss-white/60 transition-colors hover:bg-moss-grey-500/50 hover:text-moss-white',
      className,
    )}
    aria-label={muted ? 'Unmute' : 'Mute'}
  >
    {muted ? (
      <>
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
          <line x1="23" y1="9" x2="17" y2="15" />
          <line x1="17" y1="9" x2="23" y2="15" />
        </svg>
        <span className="hidden md:inline">Better with music</span>
      </>
    ) : (
      <>
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
          <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
          <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
        </svg>
        <span className="hidden md:inline">Turn music off</span>
      </>
    )}
  </button>
)
